import React from 'react';
import PropTypes from 'prop-types';
import {Button, Form, Icon} from 'semantic-ui-react';
import {EmptyFunc} from "utils/DBUtils";
import {FormattedMessage} from "react-intl";
import {TextInput} from "../forms/BasicFormFields";

class ImageButtons extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            enteringId: false,
            enteredId: ""
        }
    }

    startEnterId = () => {
        this.setState({
            enteringId: true
        });
    };

    endEnterId = () => {
        this.setState({
            enteringId: false,
            enteredId: ""
        });
    };

    enterId = () => {
        this.props.onIdEntered(this.state.enteredId.replace(/\s+/g, ''));
    };

    updateId = (value) => {
        this.setState({
            enteredId: value
        })
    };

    render() {
        return this.state.enteringId ? (
                <Form className='image-id-input'>
                    <TextInput name={'id'} onValueChanged={this.updateId} value={this.state.enteredId}/>
                    <div className="image-id-input-cancel">
                        <Button onClick={this.enterId}>Enter</Button>
                        <Button onClick={this.endEnterId}>Cancel</Button>
                    </div>
                </Form>
                ) : (
                <Button.Group>
                    <Button disabled={this.props.disabled}
                            type="button"
                            primary
                            onClick={() => this.props.onBrowse()}>
                        <Icon name="folder open"/> <FormattedMessage id={'buttons.upload'}/>
                    </Button>
                    {this.props.allowIdInput ? (
                        <React.Fragment>
                            <Button.Or/>
                            <Button primary onClick={this.startEnterId}>
                                <FormattedMessage id={'buttons.image.enter.id'}/>
                            </Button>
                        </React.Fragment>
                    ) : ""}
                </Button.Group>
        );
    }
}

ImageButtons.propTypes = {
    disabled: PropTypes.bool,
    onBrowse: PropTypes.func,
    onIdEntered: PropTypes.func,
    allowIdInput: PropTypes.bool
};

ImageButtons.defaultProps = {
    disabled: false,
    onBrowse: EmptyFunc,
    allowIdInput: true
};

export default ImageButtons;



// WEBPACK FOOTER //
// ./public/components/images/ImageButtons.jsx